import { useLogout } from '@common/uaa';
import { useRouter } from 'next/router';

export default function SignOut() {
  const router = useRouter();

  useLogout({
    onSuccess: () => {
      router?.replace('/sign-in');
    },
  });

  return null;
}
